/**
 * @file 块列表 context
 */
import { AxiosResponsePromise } from '@seiue/axios'
import { createContext } from 'react'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { BlockTypeEnum, Paper, PaperBlock } from 'packages/sdks-next/growp'

export const HandoutBlockListContext = createContext<{
  paper: Paper
  blocks: PaperBlock[] | null
  blockMovable: boolean
  initialState: BlockStateEnum
  availableStates: BlockStateEnum[]
  groupDraggingId: number
  setGroupDraggingId: (i: number) => void
  // answerData?: AnswerData | null
  // reviewData?: ReviewData | null
  // onBlockAnswer?: (blockId: number, answer: AnswerReq) => void
  // statData?: AnswerStatData | null
  // onBlockReview?: (blockId: number, review: ExtendedCreateReview) => void
  isPublished: boolean
  isStudent: boolean
  // isAdmin: boolean
  hasAnswered: boolean
  canEdit: boolean
  api: {
    createBlock: (
      weight: number,
      type: BlockTypeEnum,
      parentId: number
    ) => AxiosResponsePromise<PaperBlock>
    deleteBlock: ({
      blockId,
      onlyDeleteSelf,
    }: {
      blockId: number
      onlyDeleteSelf?: boolean | undefined
    }) => Promise<void>
    updateBlock: (block: PaperBlock) => Promise<void>
    batchUpdateBlock: (blks: PaperBlock[]) => AxiosResponsePromise<number>
  }
}>(null as any)
